import clsx from 'clsx';
import { useState } from 'react';

import { ProgressiveImage } from '@gitbook/spine-react';

import churroLoginImage from './assets/churro-login.webp';
import churroOnboardingImage from './assets/churro-onboarding.webp';

export function ChurroAsideBg(props: { kind?: 'login' | 'onboarding' }) {
    const { kind = 'onboarding' } = props;
    const [isLoaded, setIsLoaded] = useState(false);

    const churroImage = {
        login: churroLoginImage,
        onboarding: churroOnboardingImage,
    }[kind];

    return (
        <ProgressiveImage
            rounded={false}
            resize={false}
            src={{ light: churroImage, dark: churroImage }}
            alt="Abstract asset used in the GitBook brand"
            loading="eager"
            fetchPriority="high"
            className={clsx(
                'absolute left-0 size-full',
                'transition-[filter,opacity] duration-700 ease-out',
                isLoaded ? 'blur-0 opacity-100' : 'opacity-0 blur-[16px]'
            )}
            onLoad={() => setIsLoaded(true)}
        />
    );
}
